import { RoutesMap } from '../../models/routes-map/routes-map.model';
import { environment } from '../../../environments/environment';

export const CreateRoutesMap: RoutesMap = {
  index: {
    path: `/${environment.modules.create}`,
    label: 'Create'
  }
};
